
<script>
import { mixin as clickaway } from 'vue-clickaway'
import filtersField from '@/components/services/ui/filtersField.vue'
import {
  RexCheckboxesGroup,
  RexDistance,
  RexSlider,
  RexSelect
} from '@/components/views/rexFieldsV2'
import { formatThousands } from '@/utils/helpers'

export default {
  name: 'hotels-filter',
  components: {
    filtersField,
    RexCheckboxesGroup,
    RexDistance,
    RexSlider,
    RexSelect,
  },
  mixins: [
    clickaway
  ],
  data: () => ({
    quickFilterButton: {
      isShow: false,
      offsetTop: 0,
    }
  }),
  computed: {
    isLoading() {
      return this.$store.getters['hotelsSearch/isLoading']
    },
    isDisabled() {
      return this.$store.getters['hotelsSearch/isFiltersDisabled']
    },
    isLoaded() {
      return this.$store.getters['hotelsSearch/isFiltersLoaded']
    },
    searchForm() {
      return this.$store.getters['hotelsSearch/getFormForSearch']
    },
    collectionFilters() {
      return this.$store.getters['hotelsSearch/getCollectionFilters']
    },
    minPrices() {
      return this.$store.getters['hotelsSearch/getMinPrices']
    },
    currencySign() {
      const { currencies } = this.$store.getters.getDictionary('hotelsSearch.dictionaries')
      const { currency } = this.$store.getters['toursSearch/getForm']

      let sign = null

      if (currencies.length) {
        sign = currencies.find(item => item.slug === currency).sign
      }

      return sign
    }
  },
  methods: {
    doAction(actionName) {
      this.hideQuickFilterButton()

      this.$store.commit('hotelsSearch/setIsFiltersApplied', true)

      this.$emit(actionName)
    },
    formChangeHandler({ element: { offsetTop } }) {
      this.quickFilterButton = {
        isShow: true,
        offsetTop
      }

      this.$store.commit('hotelsSearch/setIsFiltersApplied', false)
    },
    hideQuickFilterButton() {
      this.quickFilterButton = {
        isShow: false,
        offsetTop: 0
      }
    },
    getOptionsWithBadges(optionName) {
      return this.collectionFilters[optionName].map((item) => {
        const minPrices = this.minPrices[optionName]
        const { amount } = minPrices.find(minPrice => minPrice.slug === item.slug).price

        const badge = `от ${formatThousands(amount)} ${this.currencySign}`

        return {
          ...item,
          badge
        }
      })
    },
  }
}
</script>
<template>
  <div
    v-on-clickaway="hideQuickFilterButton"
    class="search-content__filters"
  >
    <div
      class="search-content__filters-content"
    >
      <b-button
        v-if="quickFilterButton.isShow"
        type="is-primary"
        :style="{
          'top':`${quickFilterButton.offsetTop}px`
        }"
        class="rex-button2 search-content__filters-quickfilter"
        @click="doAction('filter')"
      >
        Применить
      </b-button>
      <filters-field
        label="Отели"
        :is-loading="!isLoaded"
        :default-open="true"
      >
        <rex-select
          name="filtersHotels"
          store-module="hotelsSearch"
          placeholder="Название отеля"
          target="filters.hotelsId"
          :options="collectionFilters.hotelsId"
          :is-multiple="true"
          :is-tagged="true"
          :has-search="true"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        label="Регионы"
        :is-loading="!isLoaded"
        :default-open="true"
      >
        <rex-select
          name="filtersRegions"
          store-module="hotelsSearch"
          placeholder="Название региона"
          target="filters.regions"
          :options="collectionFilters.regions"
          :is-multiple="true"
          :is-tagged="true"
          :has-search="true"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        label="Звездность"
        :is-loading="!isLoaded"
        :default-open="true"
      >
        <rex-checkboxes-group
          name="filtersCategory"
          store-module="hotelsSearch"
          target="filters.category"
          :options="getOptionsWithBadges('categories')"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        v-if="isLoading || collectionFilters.meals.length"
        label="Питание"
        :is-loading="!isLoaded"
      >
        <rex-checkboxes-group
          name="filtersMeals"
          store-module="hotelsSearch"
          target="filters.meals"
          :options="getOptionsWithBadges('meals')"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        v-if="isLoading || collectionFilters.hotelType.length"
        label="Тип размещения"
        :is-loading="!isLoaded"
      >
        <rex-checkboxes-group
          name="filtersHotelType"
          store-module="hotelsSearch"
          target="filters.facts"
          :options="collectionFilters.hotelType"
          :default-show="7"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        label="Цена"
        :is-loading="!isLoaded"
        :default-open="true"
      >
        <rex-slider
          store-module="hotelsSearch"
          target="filters"
          :target-fields="['priceFrom', 'priceTo']"
          :boundary-values="[
            collectionFilters.price.priceFrom,
            collectionFilters.price.priceTo
          ]"
          :values-suffix="currencySign"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        label="Рейтинг"
        :is-loading="!isLoaded"
        :default-open="true"
      >
        <rex-slider
          store-module="hotelsSearch"
          target="filters"
          :target-fields="['ratingFrom', 'ratingTo']"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        v-if="isLoading || collectionFilters.distance.maxDistance"
        label="Расстояние от центра"
        :is-loading="!isLoaded"
      >
        <rex-distance
          name="filtersDistance"
          store-module="hotelsSearch"
          target="filters.distanceTo"
          :max-value="collectionFilters.distance.maxDistance"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        v-if="isLoading || collectionFilters.bestFor.length"
        label="Подходит для"
        :is-loading="!isLoaded"
      >
        <rex-checkboxes-group
          name="filtersMeals"
          store-module="hotelsSearch"
          target="filters.bestFor"
          :options="collectionFilters.bestFor"
          :default-show="7"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        v-if="isLoading || collectionFilters.facilities.length"
        label="Услуги в отеле"
        :is-loading="!isLoaded"
      >
        <rex-checkboxes-group
          name="filtersFacilities"
          store-module="hotelsSearch"
          target="filters.facts"
          :options="collectionFilters.facilities"
          :default-show="7"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        v-if="isLoading || collectionFilters.beach.length"
        label="Пляж"
        :is-loading="!isLoaded"
      >
        <rex-checkboxes-group
          name="filtersBeach"
          store-module="hotelsSearch"
          target="filters.facts"
          :options="collectionFilters.beach"
          :default-show="7"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        v-if="isLoading || collectionFilters.sportEntertainment.length"
        label="Спорт"
        :is-loading="!isLoaded"
      >
        <rex-checkboxes-group
          name="filtersBeach"
          store-module="hotelsSearch"
          target="filters.facts"
          :options="collectionFilters.sportEntertainment"
          :default-show="7"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <filters-field
        v-if="isLoading || collectionFilters.roomFacilities.length"
        label="Оборудование номера"
        :is-loading="!isLoaded"
      >
        <rex-checkboxes-group
          name="filtersBeach"
          store-module="hotelsSearch"
          target="filters.facts"
          :options="collectionFilters.roomFacilities"
          :default-show="7"
          :is-disabled="isDisabled"
          @change="formChangeHandler"
        />
      </filters-field>
      <div class="search-content__filters-button-wrap">
        <b-button
          class="rex-button2"
          type="is-primary"
          expanded
          :disabled="isLoading || isDisabled"
          @click="doAction('filter')"
        >
          Фильтровать
        </b-button>
        <button
          class="search-content__filters-reset-button"
          :disabled="isLoading || isDisabled"
          @click="doAction('reset')"
        >
          Сбросить фильтры
        </button>
      </div>
    </div>
  </div>
</template>
